/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  AppleTokenProvisionRequestDto,
  AppleTokenProvisionResponseDto,
  DigitalWalletDataDto,
  DigitalWalletTokenDto,
  GoogleTokenProvisionRequestDto,
  GoogleTokenProvisionResponseDto,
  WalletSplashScreenDetailsDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class MobileApiDigitalWalletsController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags mobile-api-digital-wallets-controller
   * @name ApproveTokenProvision
   * @request PUT:/api/m/digital-wallets/card/{cardId}/token/{tokenId}/provision/approval
   */
  approveTokenProvision = (cardId: string, tokenId: string, params: RequestParams = {}) =>
    this.http.request<DigitalWalletTokenDto, any>({
      path: `/m/digital-wallets/card/${cardId}/token/${tokenId}/provision/approval`,
      method: 'PUT',
      format: 'json',
      ...params,
    })

  static approveTokenProvisionPath =
    '/m/digital-wallets/card/${cardId}/token/${tokenId}/provision/approval'
  static approveTokenProvisionMethod = 'PUT'
  /**
   * No description
   *
   * @tags mobile-api-digital-wallets-controller
   * @name RequestTokenProvisionGooglePay
   * @request POST:/api/m/digital-wallets/provision/googlepay
   */
  requestTokenProvisionGooglePay = (
    data: GoogleTokenProvisionRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<GoogleTokenProvisionResponseDto, any>({
      path: `/m/digital-wallets/provision/googlepay`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static requestTokenProvisionGooglePayPath = '/m/digital-wallets/provision/googlepay'
  static requestTokenProvisionGooglePayMethod = 'POST'
  /**
   * No description
   *
   * @tags mobile-api-digital-wallets-controller
   * @name RequestTokenProvisionApplePay
   * @request POST:/api/m/digital-wallets/provision/applepay
   */
  requestTokenProvisionApplePay = (
    data: AppleTokenProvisionRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<AppleTokenProvisionResponseDto, any>({
      path: `/m/digital-wallets/provision/applepay`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static requestTokenProvisionApplePayPath = '/m/digital-wallets/provision/applepay'
  static requestTokenProvisionApplePayMethod = 'POST'
  /**
   * No description
   *
   * @tags mobile-api-digital-wallets-controller
   * @name GetTokensForCard
   * @request GET:/api/m/digital-wallets/card/{cardId}/wallet/data
   */
  getTokensForCard = (cardId: string, params: RequestParams = {}) =>
    this.http.request<DigitalWalletDataDto, any>({
      path: `/m/digital-wallets/card/${cardId}/wallet/data`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getTokensForCardPath = '/m/digital-wallets/card/${cardId}/wallet/data'
  static getTokensForCardMethod = 'GET'
  /**
   * No description
   *
   * @tags mobile-api-digital-wallets-controller
   * @name GetTokenizableCardsForUser
   * @request GET:/api/m/digital-wallets/card/wallet/data
   */
  getTokenizableCardsForUser = (params: RequestParams = {}) =>
    this.http.request<WalletSplashScreenDetailsDto[], any>({
      path: `/m/digital-wallets/card/wallet/data`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getTokenizableCardsForUserPath = '/m/digital-wallets/card/wallet/data'
  static getTokenizableCardsForUserMethod = 'GET'
  /**
   * No description
   *
   * @tags mobile-api-digital-wallets-controller
   * @name GetDetailsForSplashScreen
   * @request GET:/api/m/digital-wallets/card/splashscreen
   */
  getDetailsForSplashScreen = (params: RequestParams = {}) =>
    this.http.request<WalletSplashScreenDetailsDto, any>({
      path: `/m/digital-wallets/card/splashscreen`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getDetailsForSplashScreenPath = '/m/digital-wallets/card/splashscreen'
  static getDetailsForSplashScreenMethod = 'GET'
}
